import axios from 'axios';

const axiosServices = axios.create();

//MB => DO NOT USE THIS INSTANCE OF AXIOS, its immediately mocked and will not call external services

// ==============================|| AXIOS - FOR MOCK SERVICES ||============================== //

axiosServices.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Wrong Services')
);

export default axiosServices;
